import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Float from "../components/float";
import Footer from "../components/footer";

import Info from "../components/payu/info";

export default class Payu extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: '',
            error: null,
            brands:[],
            brands_2:[],
            categories:[],
            info:[],
        }
    }

    async componentDidMount(){
        //informacion
        try{
            let res = await fetch(https+'api/info')
            let data = await res.json()
            this.setState({
                info:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands
        try{
            let res = await fetch(https+'api/brandsHeader')
            let data = await res.json()
            this.setState({
                brands:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands 2
        try{
            let res = await fetch(https+'api/brandsHeader2')
            let data = await res.json()
            this.setState({
                brands_2:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //categories
        try{
            let res = await fetch(https+'api/categoriesHeader')
            let data = await res.json()
            this.setState({
                categories:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }
    render() {
        return (
            <div>
                <Header
                    brands={this.state.brands}
                    brands_2={this.state.brands_2}
                    categories={this.state.categories}
                />
                <Info
                    orders={this.state.orders}
                    products={this.state.products}
                />
                <Float
                    info={this.state.info}
                />
                <Footer
                    info={this.state.info}
                />
            </div>
        );
    }

}

if (document.getElementById('content_payu')) {
    ReactDOM.render(<Payu />, document.getElementById('content_payu'))
}
